import { render, staticRenderFns } from "./SIcon.vue?vue&type=template&id=eac657e6&functional=true&"
import script from "./SIcon.vue?vue&type=script&lang=js&"
export * from "./SIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports